<template>
  <div>
    <q-field error-label="Invalid Date">
      <q-search v-model="filter" :placeholder="placeholder" v-if="!hide">
        <q-autocomplete 
          ref="StudentAutoComplete"
          :debounce="500"
          :max-results="maxResults"
          :disable="disable"
          @search="onSearch"
          @selected="onSelect"
        />
      </q-search>
    </q-field>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'StudentAutoComplete',
  props: ['onSelect', 'hide'],
  data () {
    return {
      filter: null,
      placeholder: 'Start typing a name or email',
      maxResults: 5
    }
  },
  computed: {
    ...mapGetters('students', [
      'autoCompleteOptions'
    ])
  },
  methods: {
    ...mapActions('students', [
      'fetchAutoComplete'
    ]),
    onSearch (s, done) {
      this.fetchAutoComplete({ s })
      setTimeout(() => {
        done(this.autoCompleteOptions)
      }, 1000)
    }
  }
}
</script>

<style>
</style>
